import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                prev: 'prev',
                next: 'next'
            }
        }
    }

    init() {

        this.swiper = new Swiper(this.el, {
            speed: 400,
            slidesPerView: 1,
            breakpoints: {
                1024: {
                    slidesPerView: 3
                }
            }
        });

        this.swiper.on('slideChange', (e) => {

            if(this.swiper.isEnd) {
                this.el.classList.add('is-end');
            } else {
                this.el.classList.remove('is-end');
            }

            if(this.swiper.isBeginning) {
                this.el.classList.add('is-beginning');
            } else {
                this.el.classList.remove('is-beginning');
            }
        });

        if(this.swiper.isEnd) {
            this.el.classList.add('is-end');
        } else {
            this.el.classList.remove('is-end');
        }

        if(this.swiper.isBeginning) {
            this.el.classList.add('is-beginning');
        } else {
            this.el.classList.remove('is-beginning');
        }
    }

    prev() {
        this.swiper.slidePrev();
    }

    next() {
        this.swiper.slideNext();
    }
}
